import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import TextInput from "components/FormElements/TextInput";
import CheckboxInput from "components/FormElements/CheckboxInput";
import SignInLogo from "assets/svg/Logo";
import EmailFieldInput from "components/FormElements/EmailFieldInput";
import PasswordIconText from "assets/svg/PasswordIconText";
import EndIcon from "assets/svg/PasswordShowIcon";
import AlertModal from "components/AlertModal";
import { auth } from "redux/actions/auth";
import { setCountry } from "redux/actions/countrySelection";
import { getAuthInitialValues, VALIDATION_SCHEMA } from "utils/authUtils";
import Button from "components/Button";
import LeftContainer from "components/LeftContainer";
import { RememberSection, Heading, SubHeading } from "styles/pages/login";
import { BodyContainer, RegistrationContainer, FormContainer, InputField, Footer, Container, RightContainer, LogoWrapper, } from "styles/pages/global";
import { useText } from "locales/useGetText";
import { getLocaleSelection } from "redux/reducers/countrySelection";

const Login = () => {
  const locale = useText("login");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    const rememberMe = localStorage.getItem("rememberMe");
    const email = localStorage.getItem("email");
    localStorage.clear();
    if (rememberMe !== null) {
      localStorage.setItem("email", email)
      localStorage.setItem("rememberMe", rememberMe)
    }
  }, []);

  let formObj = {
    email: localStorage.getItem('rememberMe') ? localStorage.getItem('email') : '',
    password: '',
    rememberMe: localStorage.getItem('rememberMe')
  }

  const formSubmit = async (props) => {
    const { submitForm, validateForm, setTouched, isValid } = props;

    submitForm().then(async () => {
      if (isValid) {
        let data = {
          email: props?.values?.email,
          password: props?.values?.password,
        };

        const response = await dispatch(auth(data));
        if (response?.data?.success) {
          if (props?.values?.rememberMe) {
            localStorage.setItem('email', props?.values?.email);
            localStorage.setItem('rememberMe', props?.values?.rememberMe);

            let obj = {
              email: props?.values?.email,
              password: props?.values?.password,
              rememberMe: props?.values?.rememberMe,
              token: response?.data?.data?.token
            }
            dispatch({ type: 'LOCAL_STORE_DATA', payload: obj })

          } else {
            localStorage.clear();
          }
          localStorage.setItem("loggedInUserData", JSON.stringify(response?.data?.data))
          if (response?.data?.data?.country?.toUpperCase() === "USA") {
            dispatch(setCountry(getLocaleSelection({ userCountry: "USA" })));
          }
          navigate("/dashboard");
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
        window.scrollTo(0, 0);
        validateForm();
        setTouched({});
      }
    });
  };

  const formFields = () => {
    return (
      <Container>
        <LeftContainer />
        <RightContainer>
          <RegistrationContainer>
            <LogoWrapper className="login">
              <SignInLogo />
            </LogoWrapper>

            <Formik
              initialValues={getAuthInitialValues(formObj)}
              validationSchema={VALIDATION_SCHEMA(locale)}
              onSubmit={() => { }}
            >
              {(props) => {
                const { isValid, dirty, setFieldValue } = props;
                return (
                  <Form>
                    <FormContainer>
                      <InputField>
                        <div data-testid="Email*">
                          <EmailFieldInput
                            name="email"
                            placeholder={locale('email')}
                            maxLength={100}
                            showErrorMessages={true}
                          />
                        </div>
                      </InputField>

                      <InputField>
                        <div data-testid="Password*">
                          <TextInput
                            name="password"
                            type={showPassword ? "text" : "password"}
                            maxLength="20"
                            placeholder={locale('password')}
                          />
                        </div>
                        {!showPassword ? (
                          <EndIcon
                            className="passwordIcon"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          />
                        ) : (
                          <PasswordIconText
                            className="passwordIcon"
                            onClick={() => {
                              setShowPassword(!showPassword);
                            }}
                          />
                        )}
                      </InputField>

                      <RememberSection>
                        <div data-testid="Remember me">
                          <CheckboxInput
                            name="rememberMe"
                            label={locale('rememberMe')}
                            onChange={(val) => {
                              setFieldValue("rememberMe", val);
                            }}
                          />
                        </div>
                        <h5
                          className="forgotPassword"
                          onClick={() => navigate("/forgot-password")}
                        >
                          {locale('forgotPassword')}
                        </h5>
                      </RememberSection>
                      <Footer>
                        <Button
                          disabled={!localStorage.getItem('rememberMe') && !(isValid && dirty)}
                          handleClick={() => formSubmit(props)}
                        >
                          {locale('signIn')}
                        </Button>
                      </Footer>
                    </FormContainer>

                    <AlertModal
                      isOpen={modal}
                      toggle={toggleModal}
                      title="Alert"
                      content={modalContent}
                      link={modalLink}
                      className="alert-msg-container"
                      InnerClassName="alert-msg"
                    />
                  </Form>
                );
              }}
            </Formik>
          </RegistrationContainer>
        </RightContainer>
      </Container>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default Login;
